import { Button, ModalPortal, P } from '@vgrubs/components';

export const BankTerms = ({
  isOpen,
  onBack,
  onAgree,
}: {
  isOpen: boolean;
  onBack: () => void;
  onAgree: () => void;
}) => {
  return (
    <ModalPortal
      isOpen={isOpen}
      header="vGrubs Terms"
      onBack={onBack}
      exitButton={false}
    >
      <P $mb="32">
        I authorize vGrubs to electronically credit my bank account via ACH for
        payouts, refunds, or other disbursements. I confirm that the bank
        information I provide is accurate, and I understand that credits may be
        reversed in the event of an error or as required by applicable banking
        regulations.
      </P>
      <Button $selected $w="100%" onClick={onAgree}>
        I agree with vGrubs Terms
      </Button>
    </ModalPortal>
  );
};
